import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SpotfightEvent} from "../../core/models/models";
import { NgClass } from "@angular/common";
import {SpotfightDateFormatPipe} from "../../core/pipes/date-format/spotfight-date-format.pipe";
import {RouterLink} from "@angular/router";
import {leagueLabel} from "../../core/models/leagues";

@Component({
  selector: 'app-event-card',
  standalone: true,
  imports: [
    SpotfightDateFormatPipe,
    RouterLink,
    NgClass
],
  templateUrl: './event-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './event-card.component.scss'
})
export class EventCardComponent {
  @Input() event!: SpotfightEvent;

  protected readonly leagueLabel = leagueLabel;
}
